import * as Yup from 'yup';
import { USER_TYPE } from 'store/constant';

const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;

const userCreateSchema = Yup.object({
    firstname: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('First name is required'),
    lastname: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .notRequired(),
    email: Yup.string()
        .trim()
        .email('Invalid email address')
        .required('Email is required'),
    phone: Yup.string()
        .trim()
        .matches(/^[+0-9]+$/, 'Invalid phone number')
        .min(10, 'Invalid phone number')
        .max(10, 'Invalid phone number')
        .required('Valid phone number is required'),
    uuid_venue: Yup.array()
        .when('type', {
            is: USER_TYPE[0].value,
            then: Yup.array()
                .of(
                    Yup.string().required('Venue is required')
                )
                .min(1, 'At least one venue is required'),
            otherwise: Yup.array().notRequired()
        }),
    image: Yup.string()
        .notRequired(),
    dob: Yup.string()
        .nullable()
        .notRequired(),
    countrycode: Yup.string()
        .trim()
        .max(2, 'Must be 2 characters or less')
        .min(2, 'Must be 2 characters or less')
        .required('Country code is required'),
    type: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('User type is required'),
    gender: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('Gender is required'),
    loc_city: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('City is required'),
    password: Yup.string()
        .max(50, 'Must be 50 characters or less')
        .matches(
            PASSWORD_REGEX,
            'Password must be at least 8 characters long, include at least one letter, one number, and one special character'
        )
        .when('type', {
            is: USER_TYPE[0].value,
            then: Yup.string().required('Password is required'),
            otherwise: Yup.string().notRequired()
        }),
    confirm_password: Yup.string()
        .max(50, 'Must be 50 characters or less')
        .test(
            'confirm_password',
            'Both Password must be match!',
            (confirm_password, yup) => yup.parent.password === confirm_password
        )
        .when('type', {
            is: USER_TYPE[0].value,
            then: Yup.string().required('Confirm password is required'),
            otherwise: Yup.string().notRequired()
        })
});

export default userCreateSchema;